import { CSSProperties, FC } from 'react'

import { getUserName } from 'services/Utilities'
import { Card } from 'ui'

type Props = {
  containerClass?: string
  id: string
  maxHeight?: number | string
  usersIds: string[]
}
const ScrollableUserList: FC<Props> = ({ maxHeight = '10rem', containerClass = 'card bg-light mb-3', id, usersIds }) => {
  const styles: CSSProperties = {
    maxHeight,
    overflow: 'auto'
  }

  return (
    <div style={styles} className={containerClass} id={id}>
      <Card.Body className="body">
        <div className="row pb-4">
          {usersIds.map(userId => (
            <div key={userId} className="col-4">
              {getUserName(userId)}
            </div>
          ))}
        </div>
      </Card.Body>
    </div>
  )
}
export default ScrollableUserList
